import {
  DataTable,
  EmptyState,
  Pagination,
  type DataTableColumn,
  type DataTableError,
} from "@playbookai/ui";

/** A DataTable with the console's shared cursor pager beneath it. Used by both
    GenAI tables; the page owns the cursor, this owns nothing. */
export function PagedTable<T>({
  rows,
  columns,
  id,
  caption,
  loading,
  error,
  paging,
}: {
  rows: T[];
  columns: DataTableColumn<T>[];
  id: (row: T) => string;
  caption: string;
  loading: boolean;
  /* The failure belongs INSIDE the table. Swapping the table for an Alert threw
     the header row away, so a failed load collapsed the whole region and the
     reader lost the columns they were reading a moment earlier. */
  error?: DataTableError | undefined;
  paging: {
    page: number;
    totalCount?: number | undefined;
    canGoBack: boolean;
    hasNext: boolean;
    busy: boolean;
    onPrev: () => void;
    onNext: () => void;
  };
}) {
  return (
    <>
      <DataTable
        columns={columns}
        data={rows}
        getRowId={id}
        caption={caption}
        textSize="small"
        nowrap
        responsive
        pinFirstColumn
        /* Every column declares a share, so the table keeps one shape whatever
           a page of rows happens to contain. */
        layout="fixed"
        loading={loading}
        error={error}
        emptyState={<EmptyState title={`No ${caption.toLowerCase()} yet`} />}
      />
      {(paging.canGoBack || paging.hasNext) && (
        <Pagination
          mode="cursor"
          page={paging.page}
          pageItemCount={rows.length}
          totalCount={paging.totalCount}
          canGoBack={paging.canGoBack}
          hasNext={paging.hasNext}
          busy={paging.busy}
          onPrev={paging.onPrev}
          onNext={paging.onNext}
        />
      )}
    </>
  );
}
